import { Injectable } from "@angular/core";
import { ClassificationStoreModel } from "../../store/classification.store.model";
import {
  DEFAULT_CLASSIFICATION_ID,
  DEFAULT_CLASSIFICATION_NAME,
} from "../../constants/classification.constants";
import { ClassificationView } from "./classification.view";
import { UserStoreService } from "../../../services/store/user/user.store.service";
import { checkDuplicateName } from "@bitwarden/web-vault/app/shared/utils/helper-new-view-name";

@Injectable({ providedIn: "root" })
export class ClassificationUtils {
  async addNewClassification(
    classificationName: string,
    userStoreService: UserStoreService,
  ): Promise<ClassificationView> {
    if (!this.hasDuplicatedName(userStoreService, classificationName)) {
      const newClassification = new ClassificationView();
      newClassification.name = classificationName;
      const isSaved = await userStoreService.classifications.save(newClassification);
      if (isSaved && newClassification.id) {
        return newClassification;
      } else {
        throw new Error("Classification could not be saved");
      }
    }
    throw new Error("duplicateNameError");
  }

  async updateClassificationName(
    newName: string,
    classification: ClassificationView,
    userStoreService: UserStoreService,
  ): Promise<ClassificationView> {
    if (classification.id === DEFAULT_CLASSIFICATION_ID) {
      return null;
    }

    if (this.hasDuplicatedName(userStoreService, newName)) {
      throw new Error("duplicateNameError");
    }

    classification.name = newName;
    const isSaved = await userStoreService.classifications.save(classification);
    return isSaved ? classification : null;
  }

  hasDuplicatedName(userStoreService: UserStoreService, newName: string): boolean {
    return checkDuplicateName(
      userStoreService.classifications.classificationViewsSorted(),
      newName,
    );
  }

  static getDefaultClassificationModel() {
    const classificationStoreModel: ClassificationStoreModel = {
      dc: new Date().toISOString(),
      dm: new Date().toISOString(),
      gd: true,
      id: DEFAULT_CLASSIFICATION_ID,
      n: DEFAULT_CLASSIFICATION_NAME,
      v: 2,
      vid: null,
    };
    return classificationStoreModel;
  }

  static getDefaultClassificationView(): ClassificationView {
    return new ClassificationView(this.getDefaultClassificationModel());
  }
}
